<template>
  <div class="checkout__info">
    <div class="checkout__info-column">
      <div class="checkout__info-item" v-if="car.seats">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/people.svg" alt=""></div>
        <div class="checkout__info-title">Количество мест</div>
        <div class="checkout__info-value">{{car.seats}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.drive_type_name">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/drive.svg" alt=""></div>
        <div class="checkout__info-title">Привод</div>
        <div class="checkout__info-value">{{car.drive_type_name}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.color">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/car.svg" alt=""></div>
        <div class="checkout__info-title">Цвет</div>
        <div class="checkout__info-value">{{car.color}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.transmission_name">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/kpp.svg" alt=""></div>
        <div class="checkout__info-title">КПП</div>
        <div class="checkout__info-value">{{car.transmission_name}}</div>
      </div>
    </div>
    <div class="checkout__info-column" v-if="car.conditioner">
      <div class="checkout__info-item">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/snow.svg" alt=""></div>
        <div class="checkout__info-title">{{car.conditioner}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.fuel">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/fuel.svg" alt=""></div>
        <div class="checkout__info-title">Топливо</div>
        <div class="checkout__info-value">{{car.fuel}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.doors">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/door.svg" alt=""></div>
        <div class="checkout__info-title">Двери</div>
        <div class="checkout__info-value">{{car.doors}}</div>
      </div>
      <div class="checkout__info-item" v-if="car.audio">
        <div class="checkout__info-icon"><img src="@/assets/img/icons/sound.svg" alt=""></div>
        <div class="checkout__info-title">Аудио</div>
        <div class="checkout__info-value">{{car.audio.join(',')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'CarChars',
    props: ['car'],
}
</script>
